import { useState } from "react";
import { useGlobalOptions } from "./GlobalOptionsContext";
import { getRelativeDate, getUserFriendlyDate } from "../../utils/time";

const PersonalIdentifier = (props: {
    identifier: any,
    isTime?: boolean,
}) => {
    const { isPresentation, toggleIsPresentation } = useGlobalOptions();
    const [useRelativeTime, setUseRelativeTime] = useState(true);

    if (isPresentation) {
        return (
            <>*********</>
        );
    } else if (props.isTime) {
        if (useRelativeTime) {
            try {
                const parsedTime = new Date(props.identifier);
                return <span onClick={() => setUseRelativeTime(!useRelativeTime)}>{getRelativeDate(parsedTime)}</span>
            } catch {
                return <span onClick={() => setUseRelativeTime(!useRelativeTime)}>{props.identifier}</span>
            }
        } else {
            return <span onClick={() => setUseRelativeTime(!useRelativeTime)}>{props.identifier}</span>
        }
    } else {
        return <>{props.identifier}</>
    }

};

export default PersonalIdentifier;
